"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyMentionsInput = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importStar(require("react"));

const react_mentions_1 = require("react-mentions");

const defaultMarkup_1 = require("./defaultMarkup");

const defaultStyles_1 = require("./defaultStyles");

const defaultRenderSuggestionItem = dataTestId => {
  return suggestion => {
    const itemContent = suggestion.display;
    return react_1.default.createElement(material_1.MenuItem, {
      component: "div",
      style: {
        height: "100%",
        width: "100%"
      },
      "data-testid": `${dataTestId}-menu-item-${itemContent}`
    }, itemContent);
  };
};
/**
 * @desc Will not work on Safari (does not support lookahead/lookbehind regex)
 */


const SskyMentionsInput = props => {
  const dataTestId = props.dataTestId || "test-id-ssky-mention-input";
  const defaultRef = (0, react_1.useRef)(null);
  const inputRef = props.inputRef || defaultRef;

  const getNonMentionValueLength = value => {
    var _a;

    return (_a = value === null || value === void 0 ? void 0 : value.split(defaultMarkup_1.defaultMarkupRegex).join("").length) !== null && _a !== void 0 ? _a : 0;
  };

  const numOfMentions = (0, react_1.useMemo)(() => {
    var _a, _b;

    return (_b = ((_a = props.value) === null || _a === void 0 ? void 0 : _a.split(defaultMarkup_1.defaultMarkupRegex).length) - 1) !== null && _b !== void 0 ? _b : 0;
  }, [props.value]);
  const helperText = (0, react_1.useMemo)(() => {
    if (props.showTextLimit && props.maxNonMentionChars) {
      return react_1.default.createElement("span", {
        style: {
          display: "flex"
        }
      }, react_1.default.createElement("span", {
        style: {
          flexGrow: 1
        }
      }, props.helperText), react_1.default.createElement("span", {
        style: {
          whiteSpace: "nowrap",
          marginLeft: "5px"
        }
      }, getNonMentionValueLength(props.value), " / ", props.maxNonMentionChars));
    } else {
      return props.helperText;
    }
  }, [props.showTextLimit, props.maxNonMentionChars, props.value, props.helperText]); // This useEffect fixes a bug: https://sundaysky.atlassian.net/browse/SD-2273

  (0, react_1.useEffect)(() => {
    const currentInputRef = inputRef.current;

    const handleCopy = e => {
      e.preventDefault();
      e.stopPropagation();
      e.clipboardData.setData("text/plain", window.getSelection().toString());
    };

    currentInputRef.addEventListener("copy", handleCopy);
    return () => {
      currentInputRef.removeEventListener("copy", handleCopy);
    };
  }, [inputRef.current]);
  (0, react_1.useEffect)(() => {
    const currentInputRef = inputRef.current;

    const handlePaste = e => {
      if (props.maxNonMentionChars) {
        e.preventDefault();
        e.stopPropagation();
        let textToPaste = e.clipboardData.getData("Text");
        const numOfCharsOverLimit = textToPaste.length + getNonMentionValueLength(props.value) - props.maxNonMentionChars;

        if (numOfCharsOverLimit > 0) {
          textToPaste = textToPaste.slice(0, -numOfCharsOverLimit);
        }

        document.execCommand('insertText', false, textToPaste);
      }
    };

    currentInputRef.addEventListener("paste", handlePaste);
    return () => {
      currentInputRef.removeEventListener("paste", handlePaste);
    };
  }, [inputRef.current, props.value, props.maxNonMentionChars]); // This useEffect fixes a bug: https://sundaysky.atlassian.net/browse/SD-2465

  (0, react_1.useEffect)(() => {
    const ref = inputRef.current;

    if (ref.selectionStart === ref.selectionEnd) {
      ref.selectionStart++;
    }
  }, [numOfMentions]);

  const handleChange = event => {
    var _a;

    if (!props.maxNonMentionChars || getNonMentionValueLength(event.target.value) <= props.maxNonMentionChars) {
      (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event.target.value);
    }
  };

  return react_1.default.createElement(defaultStyles_1.StyledFormControl, {
    className: props.className,
    error: props.error,
    disabled: props.disabled,
    value: props.value
  }, react_1.default.createElement(react_mentions_1.MentionsInput, {
    allowSpaceInQuery: props.allowSpaceInQuery,
    allowSuggestionsAboveCursor: props.allowSuggestionsAboveCursor,
    autoFocus: props.autoFocus,
    className: (0, classnames_1.default)(defaultStyles_1.mentionInputClassName, props.inputClassName),
    "data-testid": dataTestId,
    inputRef: inputRef,
    disabled: props.disabled,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onChange: handleChange,
    singleLine: !props.multiline,
    value: props.value
  }, react_1.default.createElement(react_mentions_1.Mention, {
    appendSpaceOnAdd: props.appendSpaceOnAdd,
    displayTransform: props.displayTransform,
    isLoading: props.isLoading,
    onAdd: props.onAdd,
    renderSuggestion: props.renderSuggestionItem || defaultRenderSuggestionItem(dataTestId),
    trigger: props.trigger,
    data: numOfMentions < props.maxNumOfMentions ? props.suggestions : [],
    style: Object.assign(Object.assign({}, defaultStyles_1.defaultMentionStyle), props.mentionStyle)
  })), react_1.default.createElement("label", {
    className: defaultStyles_1.floatingLabelClassName
  }, props.placeholder), react_1.default.createElement(material_1.FormHelperText, null, helperText));
};

exports.SskyMentionsInput = SskyMentionsInput;
SskyMentionsInput.defaultProps = {
  maxNumOfMentions: Infinity
};
exports.default = (0, react_1.memo)(SskyMentionsInput);